import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setDraftDialogSecond } from "store/bailiff/task/dialog/draft_dialog.action";
//
//component
//redux
//selector
//actions
export const TriggerMonitor = ({ audio }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTIONS ---------------------
  const handleUpdateSecond = useCallback(() => {
    const currentTime = audio?.currentTime;
    const round = parseFloat(currentTime?.toFixed(2));
    dispatch(setDraftDialogSecond(round));
  }, [audio.currentTime, dispatch]);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (!audio) return;
    console.log("UPDATE");
    audio.addEventListener("timeupdate", handleUpdateSecond);

    return () => {
      audio.removeEventListener("timeupdate", handleUpdateSecond);
    };
  }, [audio, dispatch, handleUpdateSecond]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerMonitor;
